const UNASSIGNED = "-1";
// Deterministic avatar palette (the "Discover (A)" design uses per-owner colours).
const AVATAR_COLORS = ["#247EFE", "#7A5AF8", "#DD2590", "#E0620D", "#067647", "#0E9384"];

const initialsOf = (name: string) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map(p => p[0]?.toUpperCase() ?? "")
    .join("") || "?";

const colorFor = (value: string) => {
  const sum = value.split("").reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return AVATAR_COLORS[sum % AVATAR_COLORS.length];
};

interface OwnerAvatarProps {
  label: string;
  value: string;
  size: number;
}

// Circular owner avatar: initials on a deterministic colour, or a dashed
// placeholder for the unassigned owner. Used by OwnerPicker's trigger + menu.
export const OwnerAvatar = ({ label, value, size }: OwnerAvatarProps) => {
  const unassigned = value === UNASSIGNED;
  return (
    <span
      style={{
        width: size,
        height: size,
        borderRadius: 999,
        display: "grid",
        placeItems: "center",
        fontSize: size <= 24 ? 10 : 11,
        fontWeight: 600,
        flexShrink: 0,
        color: unassigned ? "#98A2B3" : "#fff",
        background: unassigned ? "#F2F4F7" : colorFor(value),
        border: unassigned ? "1px dashed #E4E7EC" : "none",
      }}
    >
      {unassigned ? "?" : initialsOf(label)}
    </span>
  );
};
